import { createComponent } from '@carvana/merch-components';

export const Card = createComponent('div', {
  className:
    'flex flex-col gap-24 rounded-xl border-[1.5px] border-grey-2 bg-white p-24 m:max-h-[360px] m:flex-row m:justify-between m:gap-16 m:p-40'
});

export const CardInfoSection = createComponent('section', {
  className: 'flex min-w-[50%] flex-col justify-between'
});

export const CardHeader = createComponent('h2', {
  className: 'text-xl font-semibold m:text-[28px] m:leading-[32px]'
});

export const CardDescription = createComponent('span', {
  className: 'text-base text-grey-5 m:max-w-[500px] m:text-lg'
});

export const VehicleDetails = createComponent('div', {
  className: 'flex flex-col  bg-white pb-24 pt-16'
});

export const YearMakeModel = createComponent('span', {
  className: 'text-base font-semibold text-blue-7 m:text-xl'
});

export const TrimMileage = createComponent('span', {
  className: 'text-sm text-grey-5 m:text-base'
});

export const CardButtonBlue = createComponent('a', {
  className:
    'flex h-48 w-full cursor-pointer items-center justify-center rounded bg-blue-2 p-16 text-sm font-semibold text-white hover:bg-blue-3 hover:text-white m:h-56 m:w-[250px] m:p-20'
});

export const CardButtonWhite = createComponent('a', {
  className:
    'flex h-48 w-full cursor-pointer items-center justify-center rounded border border-blue-2 bg-white p-16 text-sm font-semibold hover:bg-blue-3 hover:text-white m:h-56 m:w-[250px] m:p-20'
});

export const CardImageSection = createComponent('section', {
  className: 'overflow-hidden  m:max-w-[560px]'
});

export const VehicleImage = createComponent('img', {
  className: 'h-full w-full rounded-md object-cover'
});
